import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { editProfileRoute } from 'App/Settings/EditProfile';
import { securityAndSignInRoute } from 'App/Settings/SecurityAndSignIn';
import { toolsRoute } from 'App/Settings/Tools';
import { advancedRoute } from 'App/Settings/Workspace/Advanced';
import { regionalSettingsRoute } from 'App/Settings/Workspace/RegionalSettings';
import { ConfigurationService } from 'Configuration/ConfigurationService';
import { isNativeClient } from 'Environment/launchResource/device';
import { LeftNavRoute } from 'Router/ReactRoute';
import { ResourceContext } from 'Workspace/ResourceProvider';
import { UserContext } from 'Workspace/UserContext';

const childRoutes: LeftNavRoute[] = [
	editProfileRoute,
	regionalSettingsRoute,
	securityAndSignInRoute,
	toolsRoute,
	advancedRoute,
];

export const getSupportedChildRoutes = (): LeftNavRoute[] => {
	return childRoutes;
};

export const shouldShowAccountSettings = (
	location: any,
	workspaceConfiguration: WorkspaceConfiguration,
	userContext: UserContext,
	resourceContext: ResourceContext
) => {
	const configurationService = new ConfigurationService(workspaceConfiguration);
	if (configurationService.isOnPremDeployment() && isNativeClient()) {
		return false;
	}
	return childRoutes.some(route =>
		route.isAvailable({
			location,
			workspaceConfiguration,
			userContext,
			resourceContext,
		})
	);
};
